import { render, staticRenderFns } from "./SprInfoTip.vue?vue&type=template&id=69961698&scoped=true"
import script from "./SprInfoTip.vue?vue&type=script&lang=ts"
export * from "./SprInfoTip.vue?vue&type=script&lang=ts"
import style0 from "./SprInfoTip.vue?vue&type=style&index=0&id=69961698&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69961698",
  null
  
)

export default component.exports